import useRefresh from 'hooks/useRefresh'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'state'
import { transformBarData, transformBoostData, transformBoostPoolData } from 'state/xVvs/helpers'
import { DeserializedBarData, DeserializedBoostData, State } from 'state/types'
import {
  fetchVvsBarPoolDataAsync,
  fetchVvsBarUserDataAsync,
  fetchVvsBoostPoolDataAsync,
  fetchVvsBoostUserDataAsync,
} from '.'

export const usePollUserVvsBar = (account) => {
  const { fastRefresh } = useRefresh()
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchVvsBarPoolDataAsync())
    if (account) {
      dispatch(fetchVvsBarUserDataAsync(account))
    }
  }, [account, dispatch, fastRefresh])
}

export const useUserVvsBar = (): { barData: DeserializedBarData; userDataLoaded: boolean } => {
  const { barData, userDataLoaded } = useSelector((state: State) => ({
    barData: state.xVvs.barData,
    userDataLoaded: state.xVvs.userDataLoaded,
  }))
  return { barData: transformBarData(barData), userDataLoaded }
}

export const usePollUserVvsBoost = (account) => {
  const { fastRefresh } = useRefresh()
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (account) {
      dispatch(fetchVvsBoostUserDataAsync(account))
    }
  }, [account, dispatch, fastRefresh])
}

export const useUserVvsBoost = (): {
  boostData: DeserializedBoostData
  userDataLoaded: boolean
} => {
  const { boostData, userDataLoaded } = useSelector((state: State) => ({
    boostData: state.xVvs.boostData,
    userDataLoaded: state.xVvs.userDataLoaded,
  }))
  return { boostData: transformBoostData(boostData), userDataLoaded }
}

export const usePollVvsBoostPoolData = () => {
  const { fastRefresh } = useRefresh()
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchVvsBoostPoolDataAsync())
  }, [dispatch, fastRefresh])
}

export const usePollVvsBoostPoolDataOnce = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(fetchVvsBoostPoolDataAsync())
  }, [dispatch])
}

export const useVvsBoostPool = () => {
  const { boostPoolData } = useSelector((state: State) => ({
    boostPoolData: state.xVvs.boostPoolData,
  }))
  return { boostPoolData: transformBoostPoolData(boostPoolData) }
}
